import { render, staticRenderFns } from "./results-table.vue?vue&type=template&id=5c0c67e4&lang=pug"
import script from "./results-table.vue?vue&type=script&lang=coffee"
export * from "./results-table.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports